import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { getGamerLinkedOfferAction } from "../../../store/actions/adminGamer";
import constant from "../../../util/constant";

const { ROUTES, BRANDING: { APP_SHORT_NAME } } = constant;

const GamerOffers = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { gameId: urlParamString } = useParams();
  const { 0: gameId } = String( urlParamString ).split( "?" );
  const { gamerId: urlParamString1 } = useParams();
  const { 0: gamerId } = String( urlParamString1 ).split( "?" );
  const reqParams = {
    gameId,
    fetchAllRecords: true,
    offerType: "Offer",
    offer: "All",
  };
  const { gamerLinkedOffers } = useSelector( state => ( {
    gamerLinkedOffers: state.adminGamer.gamerLinkedOffers.linkedOffers,
  } ) );

  useEffect( () => {
    if( gameId ) {
      dispatch( getGamerLinkedOfferAction( gamerId, reqParams ) );
    }
  }, [ gameId ] );

  return (
    <>
      <div className="games-grid-wrapper no-scrollbar">
        {Boolean( gamerLinkedOffers.length ) && gamerLinkedOffers.map( ( offer, index ) => (
          <div className="col-games-grid-box width-50" key={index}>
            <a
              href="javascript:void(0)" onClick={() =>
                history.push( {
                  pathname: ROUTES.ADMIN_GAMER_LINKED_GAMES_OFFER_DETAIL
                    .replace( ":gameId", gameId )
                    .replace( ":gamerId", gamerId )
                    .replace( ":offerId", offer.offerId ),
                  state: [ ...location.state,
                    ...[ { from: "adminGameDetail", path: location.pathname, state: location.search } ],
                  ],
                } )
              }
              className="offer-detail-box border-no-shadow">
              <div className="offer-detail-box-top">
                <div className="image-box">
                  <img src={offer.gameIcon} alt="games" />
                </div>
                <div className="offer-detail-box-top-body">
                  <div className="left-side">
                    <strong>{offer.offerName}</strong>
                    <p>{offer.startDate ?? "N/A" } - {offer.endDate ?? "N/A"}</p>
                    <p className="mb-0">{offer.offerProgress}</p>
                  </div>
                  <div className="right-side">
                    <img src={offer.partnerLogo} alt="Partner Icon" className="partner-image position-static" />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between mt-4 mb-3">
                <div className="games-tags-list-wrapper my-0">
                  <strong>Game: </strong>

                  {offer?.gameName
                    ? (
                      <div className="games-tags-list">
                        <div className="games-tags">
                          <div className="image-box">
                            {offer.gameIcon && <img src={offer.gameIcon} alt="User Icon" />}
                          </div>
                          <span>{offer.gameName}</span>
                        </div>
                      </div>
                    )
                    : <div className="games-desc-text"> <p>No game assigned</p> </div> }
                </div>
                {offer.rewardValue && (
                  <div className="games-desc-text text-right">
                    <strong className='mb-0'>Reward:</strong>
                    <p>{offer.rewardValue} { APP_SHORT_NAME } Points</p>
                  </div>
                )}
              </div>
              <div className="games-desc-text">
                <strong>Description:</strong>
                <p className="text-truncate">{offer.offerDescription}</p>
              </div>
            </a>
          </div>
        ) )}
      </div>
      {!gamerLinkedOffers?.length && (
        <div className='no-record' data-testid='no-record-found'>
                  No Offer Found
        </div>
      )}
    </> );
};

GamerOffers.propTypes = {
  gameId: PropTypes.string,
  gamerId: PropTypes.string,
};

export default GamerOffers;
